<template>
  <transition name="el-fade-in-linear">
	    <div v-show="transitionshow">      
	  	
          <el-form :inline="true" class="backborder1 demo-form-inline" size="small">
              <el-form-item>
				  <el-select v-model="query.timetype" placeholder="时间搜索类型" @change="query.ischange=true">
					  <el-option v-for="(item,index) in timetypelists" :label="item.name" :value="item.id" :key="index"></el-option>
				  </el-select>
			  </el-form-item>
              <el-form-item>
				  <el-date-picker v-model="query.date" type="daterange" style="width:100%"
					  range-separator="至"
					  start-placeholder="开始日期"
					  end-placeholder="结束日期"
					  value-format="yyyy-MM-dd" :unlink-panels="false" @change="query.ischange=true">
				  </el-date-picker>
			  </el-form-item>
              <el-form-item>
				  <el-select v-model="query.ispay" placeholder="是否支付" clearable @change="query.ischange=true">
					  <el-option v-for="(item,index) in ispaylists" :label="item.name" :value="item.id" :key="index"></el-option>
				  </el-select>
			  </el-form-item>
              <el-form-item style="width:11%">
				  <el-select v-model="query.status" placeholder="订单状态" filterable clearable @change="query.ischange=true">
					  <el-option v-for="(item,index) in orderstatus" :label="item.name" :value="item.id" :key="index"></el-option>
				  </el-select>
			  </el-form-item>

              <el-form-item>
                  <el-input placeholder="请输入天猫订单号 / 成交店铺 / 买家昵称 / 收货人姓名 / 收货人电话" v-model="query.key" clearable @keyup.enter.native="getTmalllists" @change="query.ischange=true" style="width:100%"></el-input>
              </el-form-item>
              <el-form-item>
                  <el-button type="primary" icon="el-icon-search" @click="getlists">查询</el-button>
              </el-form-item>
              <el-form-item>
                  <el-tooltip class="item" effect="dark" content="手动获取天猫订单信息" placement="top">
                      <el-button type="warning" icon="el-icon-setting" @click="handleSysTmallOrder">同步天猫订单</el-button>
                  </el-tooltip>
              </el-form-item>
              <el-form-item>
                  <el-tooltip class="item" effect="dark" content="手动获取天猫订单信息" placement="top">
                      <el-button type="success" icon="el-icon-upload2" @click="uploadTmallOrder">上传天猫订单信息</el-button>
                  </el-tooltip>
              </el-form-item>
	      </el-form>

          <div class="backborder2" style="margin-top:10px">
			  <el-table :data="lists" style="width:100%" v-loading="query.loading">
                  <el-table-column type="expand">
                      <template slot-scope="props">
                          <div class="tmall-order-reciever">
                            收货信息：{{props.row.reciever_name}}，{{props.row.receiver_phone}}，{{props.row.receiver_state}} - {{props.row.receiver_city}} - {{props.row.receiver_district}} - {{props.row.receiver_town}}（详细地址：{{props.row.receiver_address}}）
                            <el-button type="" round size="mini" @click="checksells(props.row)">查看销售出库单</el-button>
                            <el-button type="" round size="mini"  @click="getpackshippings(props.row.id)">查看物流单</el-button>
                          </div>

                          <el-table :data="props.row.goods">
                            <el-table-column label="goodsid" width="120" align="center">
                                <template slot-scope="goodsinfos">
                                    <div style="float:left;width:100%">{{goodsinfos.row.id}}</div>
                                </template>
                            </el-table-column>
                            <el-table-column label="商品名称">
                                <template slot-scope="goodsinfos">
                                    <div class="tmall-order-goods">
                                        <div class="tmall-order-goods-img">
                                            <span class="tmall-order-goods-gift" v-if="goodsinfos.row.type==2">赠</span>
                                            <img :src="goodsinfos.row.pic_path ? goodsinfos.row.pic_path : require('../../assets/default_img_mini.png')" /></div>
                                        <div class="tmall-order-goods-name">{{goodsinfos.row.item_meal_name}}</div>
                                        <div class="tmall-order-goods-spec">{{goodsinfos.row.sku_property_spec}}</div>
                                        <div class="tmall-order-goods-spec">商品ID：{{goodsinfos.row.productid}}，sku_id：{{goodsinfos.row.sku_id}}</div>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column label="价格" width="120" align="center">
                                <template slot-scope="goodsinfos">
                                    <div style="float:left;width:100%">{{goodsinfos.row.price|CFMprice}}</div>
                                </template>
                            </el-table-column>
                            <el-table-column label="数量" width="120" align="center">
                                <template slot-scope="goodsinfos">
                                    <div style="float:left;width:100%">{{goodsinfos.row.num}}</div>
                                </template>
                            </el-table-column>
                          </el-table>
                      </template>
                  </el-table-column>
                  <el-table-column label="ID" width="100" align="center">
                      <template slot-scope="orderinfos">
                          <div class="tmall-order-id-style">{{orderinfos.row.id}}</div>
                      </template>
                  </el-table-column>
                  <el-table-column label="天猫订单号" min-width="170" align="left">
                      <template slot-scope="orderinfos">
                          <div class="tmall-order-sn-style">{{orderinfos.row.trade_sn}}<div class="tmall-order-shopname-style">（卖家店铺：{{orderinfos.row.tmall_shopname}}）</div></div>
                      </template>
                  </el-table-column>
                  <!--
                  <el-table-column label="订单金额" width="110" align="center">
                      <template slot-scope="orderinfos">
                          <div>{{orderinfos.row.ordertotal|CFMprice}}</div>
                      </template>
                  </el-table-column>
                  -->
                  <el-table-column label="快递费" width="110" align="center">
                      <template slot-scope="orderinfos">
                          <div>{{orderinfos.row.post_fee|CFMprice}}</div>
                      </template>
                  </el-table-column>
                  <el-table-column label="实付金额" width="110" align="center">
                      <template slot-scope="orderinfos">
                          <div>{{orderinfos.row.payment|CFMprice}}</div>
                      </template>
                  </el-table-column>
                  <el-table-column label="下单时间" width="170" align="center">
                      <template slot-scope="orderinfos">
                          <div>{{orderinfos.row.createtime}}</div>
                      </template>
                  </el-table-column>
                  <el-table-column label="支付时间" width="170" align="center">
                      <template slot-scope="orderinfos">
                          <div>{{orderinfos.row.pay_time}}</div>
                      </template>
                  </el-table-column>
                  <el-table-column label="状态" width="170" align="center">
                      <template slot-scope="orderinfos">
                          <div class="tmall-order-ispay-style">{{orderinfos.row.ispay==0 ? '未付款' : '已付款'}}</div>
                          <div class="tmall-order-status-style" v-if="orderinfos.row.status==0">没有创建支付宝交易</div>
                          <div class="tmall-order-status-style" v-if="orderinfos.row.status==1">等待买家付款</div>
                          <div class="tmall-order-status-style" v-if="orderinfos.row.status==3">卖家部分发货</div>
                          <div class="tmall-order-status-style" v-if="orderinfos.row.status==4">等待卖家发货</div>
                          <div class="tmall-order-status-style" v-if="orderinfos.row.status==5">等待买家确认收货</div>
                          <div class="tmall-order-status-style" v-if="orderinfos.row.status==6">买家已签收,货到付款专用</div>
                          <div class="tmall-order-status-style" v-if="orderinfos.row.status==7">交易成功</div>
                          <div class="tmall-order-status-style" v-if="orderinfos.row.status==8">付款以后用户退款成功，交易自动关闭</div>
                          <div class="tmall-order-status-style" v-if="orderinfos.row.status==9">付款以前，卖家或买家主动关闭交易</div>
                          <div class="tmall-order-status-style" v-if="orderinfos.row.status==10">国际信用卡支付付款确认中</div>
                          <div class="tmall-order-status-style" v-if="orderinfos.row.status==11">0元购合约中</div>
                          <div class="tmall-order-status-style" v-if="orderinfos.row.status==12">拼团中订单或者发货强管控的订单，已付款但禁止发货</div>
                      </template>
                  </el-table-column>
                  <el-table-column label="是否生成出库单" width="120" align="center">
                      <template slot-scope="orderinfos">
                          <el-button type="warning" v-if="orderinfos.row.issend==2" round size="small" @click="createsells(orderinfos.row.id)">生成出库单</el-button>
                          <div v-if="orderinfos.row.issend==1" style="font-size:13px;">已生成</div>
                      </template>
                  </el-table-column>
                  <el-table-column label="是否物流信息同步至天猫" width="120" align="center">
                      <template slot-scope="orderinfos">
                          <el-button type="warning" v-if="orderinfos.row.issysnshipping==0" round size="small" @click="sysshippings(orderinfos.row.id)">去同步</el-button>
                          <div v-if="orderinfos.row.issysnshipping==1" style="font-size:13px;">已同步</div>
                      </template>
                  </el-table-column>
              </el-table>

              <div class="block">
		      <!--分页begin-->
		      <el-pagination
			  	  @size-change="querypageSizeChange" 
			  	  @current-change="querypageCurrentChange"
		      	  :current-page="query.p"
		          :page-sizes="[10, 20, 50]"
		          :page-size="query.rollpage"
		          layout="total, sizes, prev, pager, next, jumper"
		          :total="query.rows">
		      </el-pagination>
		      <!--分页end-->
	      	  </div>
          </div>


          <!-- 手动获取天猫订单信息到本地 -->
          <el-dialog title="手动获取天猫订单信息到本地" :visible.sync="getTmallOrderDialog" top="10vh" width="65%">
             <div v-loading="Tmallorders.loading" style="display:inline-block;width:100%">
             <div class="Tmall-notice-warning">温馨提示： 录入数据请用：订单号 | 收货人信息 格式，多个订单用;号隔开。如：123456 | 张三,86-13300000000,广西省 南宁市 青秀区 xxxxxx; 67891 | 李四,86-13300000001,广西省 南宁市 五象新区 xxxxxx;</div>
             <div class="Tmall-notice-title">
                <div :class=" index==Tmallorders.index ?  'Tmall-notice-title-infos Tmall-title-actived' : 'Tmall-notice-title-infos' " v-for="(item,index) in steplists" :key="index">
                   <span class="Tmall-notice-title-number">{{item.number}}</span>
                   <span class="Tmall-notice-title-line"></span>
                   <div class="Tmall-notice-title-content">
                      <span class="Tmall-notice-title-content-big">{{item.title}}</span>
                   </div>
                </div>
             </div>

             <el-input v-if="Tmallorders.index==0" v-model="Tmallorders.showorder1" type="textarea" placeholder="请填写天猫订单号，格式为：订单号|收货人信息，多个订单用;号隔开"  :autosize="{ minRows: 6, maxRows: 8}" style="margin-top:30px;font-size:14px;"/>
             <div v-if="Tmallorders.index==1 && Tmallorders.showorder2.length > 0" style="margin-top:20px;display:inline-block;width:100%">
                <div style="display:inline-block;width:calc(100% - 40px);text-align:right;padding:10px 20px 20px 20px;color:red;font-size:13px">共 {{Tmallorders.showorder2.length}} 单</div>
                <div v-for="(item,index) in Tmallorders.showorder2" :key="index" class="Tmall-notice-orderlists">{{item}}</div>
             </div>

             <div slot="footer" class="dialog-footer" style="text-align:right;margin-top:20px;">
                 <el-button size="small" round @click="upstep" v-if="Tmallorders.index==1">上 一 步</el-button>
                 <el-button size="small" round @click="nextstep" v-if="Tmallorders.index==0">下 一 步</el-button>
                 <el-button type="success" size="small" round v-if="Tmallorders.index==1" @click="saveTmallorder">完 成</el-button>
             </div>
             </div>
          </el-dialog>


          <!-- 拉取数据加载页 -->
          <div class="tmall-order-down-loading" :style="showorderloading"> 
              <div class="tmall-order-down-loading-main">
                  <div class="tmall-order-down-main-notice">同步天猫订单需要一点时间，请勿关闭当前页面</div>
                  <div class="tmall-order-down-main-percentout">
                      loading...
                      <span class="tmall-order-down-main-percent" :style="loadingpercent"></span>
                  </div>
              </div>
          </div>


          <!-- 展示错误信息 -->
          <el-dialog title="错误提示" :visible.sync="errorshowDialog" width="60%" top="10vh">
              <div class="tmall-order-down-error-shows" v-for="(item,index) in errorshows">
                <img src="../../assets/error.png" />
                {{item}}
              </div>
          </el-dialog>

          
          <!-- 天猫订单号上传 -->
          <input id="fileupload" type="file" @change="importfile(this)"  accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" style="display:none" title="1"/>
          <el-dialog title="批量导入天猫订单" :visible.sync="uploadDialog" width="70%" top="10vh">
              <div v-loading="uploadloading">
                  <el-button type="warning" size="small" icon="el-icon-download" @click="downmodel">下载模板</el-button>
                  <el-button type="warning" size="small" icon="el-icon-upload2" @click="uploadmodel">上传模板</el-button>
                  <el-button type="primary" size="small" @click="savemodel" style="float:right">保存订单</el-button>
                  <div class="tmall-upload-total">共 {{uploadLists.length}} 个订单</div>
                  <el-table :data="uploadLists">
                        <el-table-column prop="sort" label="序号" align="left" width="100"/>
                        <el-table-column prop="trade_sn" label="订单号" align="left"></el-table-column>
                        <el-table-column prop="name" label="收货人姓名" align="center" width="130"></el-table-column>
                        <el-table-column prop="phone" label="收货人电话" align="center" width="120"></el-table-column>
                        <el-table-column prop="address" label="收货人详细地址" align="left" width="230"></el-table-column>	  		  	          
                        <el-table-column label="操作" width="100" align="center">
                            <template slot-scope="scope">
                                <el-button type="danger" size="mini" circle icon="el-icon-delete" @click="delupload(scope.$index)"></el-button>
                            </template>
                        </el-table-column>
                  </el-table>
                  <div style="display:inline-block;width:100%;padding:20px 0">
                  <el-button type="primary" size="small" @click="savemodel" style="float:right">保存订单</el-button>
                  </div>
              </div>
          </el-dialog>


          <!-- 查看出库单信息 -->
          <el-dialog title="出库单信息" :visible.sync="sellDialog"  width="65%" top="10vh">
			<div v-loading="sellloading" v-if="selllists.length==0" style="width:100%;height:200px;background:rgb(211,211,211,0.3);border-radius:6px;font-size:14px;font-weight:500;display:flex;justify-content:center;align-items:center">
				<img src="../../assets/packet.png" style="width:40px;height:40px"/>
				<span style="float:left;margin-left:1%">暂无出库单信息</span>
			</div>
			<div v-loading="sellloading" v-for="(item,index) in selllists" :key="index" style="display:inline-block;width:96%;padding:2%;background:rgb(211,211,211,0.3);border-radius:6px;margin-bottom:20px">
				<el-col :span="24">
					<el-col :span="24">{{item.documents}}</el-col>
					<el-col :span="24">收货人：{{item.name}}</el-col>
					<el-col :span="6">手机号码：{{item.phone}}</el-col>
					<el-col :span="24">详细地址：{{item.address}}</el-col>
				</el-col>
				<el-table :data="item.goods" style="float:left;width:100%;margin-top:10px">
					<el-table-column label="商品名称" prop="name"></el-table-column>
					<el-table-column label="数量" prop="nums" align="center" width="100"></el-table-column>
                    <el-table-column label="单位" prop="unit" align="center" width="100"></el-table-column>
					<el-table-column label="价格" prop="price" align="center" width="100"></el-table-column>
					<el-table-column label="小计" prop="total" align="center" width="100"></el-table-column>
                    <el-table-column label="类型" prop="type" align="center" width="100"></el-table-column>
				</el-table>
				</el-col>
			</div>
		  </el-dialog>


        <!-- 查看快递信息 -->
        <el-dialog title="查看快递信息" :visible.sync="myshippingDialog" top="10vh" width="70%" height="100%" :beforeClose="closemyshipping">
            <Showshipping  v-model="myorderid" :ordertype="myordertype" @finish="closemyshippingDialog"/>
            <div slot="footer" class="dialog-footer" style="text-align:right;margin-top:20px">
                <el-button size="small" @click="myshippingDialog = false">取 消</el-button>
            </div>
        </el-dialog>



      </div>
  </transition>  
</template>

<script>
import Showshipping from '@/components/mall/shipping/showshipping' //查看快递信息
export default {
  components: {Showshipping},
  data () {
    return {
        url:this.GLOBAL.domain+"Tmall/index",
        actionauth:'', //功能权限
		transitionshow:true,
        lists:[],
        query: {
            act:'gettmallorderlists',
            token:this.$cookies.get('token'),
            timetype:2,
            date:[],
            ispay:'',
            status:'',
            key:'',
            ischange:false,
            loading:false,
            rows:0,
            p:1,
            rollpage:10,
        },

        timetypelists:[{id:1,name:'订单创建时间'},{id:2,name:'订单支付时间'}],
        ispaylists:[{id:1,name:'已支付'},{id:2,name:'未支付'}],
        orderstatus:[
            {id:1,name:'没有创建支付宝交易'},
            {id:2,name:'等待买家付款'},
            {id:3,name:'卖家部分发货'},
            {id:4,name:'等待卖家发货'},
            {id:5,name:'等待买家确认收货'},
            {id:6,name:'买家已签收,货到付款专用'},
            {id:7,name:'交易成功'},
            {id:8,name:'付款以后用户退款成功，交易自动关闭'},
            {id:9,name:'付款以前，卖家或买家主动关闭交易'},
            {id:10,name:'国际信用卡支付付款确认中'},
            {id:11,name:'0元购合约中'},
            {id:12,name:'拼团中订单或者发货强管控的订单，已付款但禁止发货'},
        ],

        getTmallOrderDialog:false,
        steplists: [
            {number:1,title:'填写天猫订单号'},
            {number:2,title:'确认天猫订单号'},
            {number:3,title:'完成'}
        ],
        Tmallorders: {
          index:0,
          loading:false,
          showorder1:'',
          showorder2:[],
        },

        showorderloading:{display:'none'},
        loadingpercent:{width:'0%'},
        errorshows:[],
        errorshowDialog:false,
        uploadDialog:false,
        uploadLists:[],
        uploadloading:false,

        sellDialog:false,
        sellloading:false,
        selllists:[],

        myshippingDialog:false,
        myorderid:'',
        myordertype:'tmall',

    }
  },
    
  mounted(){  
    this.getactionauth();
	this.getlists(); //获取订单信息详情
    this.createLockKongMing();
  },

  watch: {
	  
  },

  filters: {
    /** 价格信息保留两位小数 **/
    CFMprice(value) {
       var price=parseFloat(value); //修剪去小数点后多余的0
       var numsobj=price.toString().split(".");	//判断小数点后有几位小数
       var result=0.00;

       if(numsobj.length==1) result=price.toFixed(2); //值为0时补充到2位
       if(numsobj.length > 1 && numsobj[1].length <= 2) result=price.toFixed(2); //值为小数点后只有1位小数时补充到2位
       if(numsobj.length > 1 && numsobj[1].length > 2) result=price; //小数点后的值超出2位时直接返回
       return result;		
    }
  },
  
  methods:{

      /** 查看订单物流信息 **/
	  getpackshippings(id) {
		  this.myorderid=id;
		  this.myshippingDialog=true;
	  },
	  closemyshippingDialog() {
		  this.myorderid='';
		  this.myshippingDialog=false;
	  },
	  closemyshipping() {
		  this.myorderid='';
		  this.myshippingDialog=false;
	  },


      //将天猫信息同步至天猫
      sysshippings(id) {
          var resource = this.$resource(this.url);
          resource.save({act:'sysshipping',token:this.$cookies.get('token'),id:id}).then((res) => {
                if(res.data.Result>0){
                    if(res.data.Result=='70001') this.$router.push('/login')
                    this.$message.error(res.data.Message);
                }else{
                    this.getlists();
                }
          }).catch((res) => {
              
          });
      },


      //查看销售出库单信息
      checksells(item) {
          this.sellDialog=true;
          this.sellloading=true;
          this.selllists=[];
          var resource = this.$resource(this.url);
          resource.save({act:'getsellinfos',token:this.$cookies.get('token'),id:item.id}).then((res) => {
                if(res.data.Result>0){
                    if(res.data.Result=='70001') this.$router.push('/login')
                    this.$message.error(res.data.Message);
                    this.sellloading=false;
                }else{
                    this.selllists = JSON.parse(Base64.decode(res.data.Data));
                    this.sellloading=false;
                }
          }).catch((res) => {
              this.sellloading=false;
          });
      },


      //删除天猫订单
      delupload(index) {
          this.$delete(this.uploadLists,index);
      },

      //下载模板
      downmodel() {
          location.href=this.GLOBAL.domain+"ChangeFile/getTmallexportmodel";
      },

      //上传订单模板信息
      uploadmodel() {
          document.getElementById("fileupload").click();
      },
      
      //解析导入文件数据
      importfile(obj) {    
    	  let _this = this;
          let inputDOM = this.$refs.inputer;

          // 通过DOM取文件数据
          this.file = event.currentTarget.files[0];                
          var rABS = false; //是否将文件读取为二进制字符串
          var f = this.file;
          var outdata;
          var nums=0;
          var address='';
          var reader = new FileReader();
          this.uploadLists=[];
          this.uploadloading=true;
          FileReader.prototype.readAsBinaryString = function(f) {
            var binary = "";
            var rABS = false; //是否将文件读取为二进制字符串
            var pt = this;
            var wb; //读取完成的数据
            var reader = new FileReader();
            reader.onload = function(e) {
            	var bytes = new Uint8Array(reader.result);
                var length = bytes.byteLength;
                for(var i = 0; i < length; i++) binary += String.fromCharCode(bytes[i]);
                var XLSX = require('xlsx');
                if(rABS) {
                	wb = XLSX.read(btoa(fixdata(binary)), {type:'base64'});
                }else {
                    wb = XLSX.read(binary, {type: 'binary'});
                }
                outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]);//outdata就是你想要的东西
                outdata.forEach(function(item,index) {
                    nums++;
                    _this.uploadLists.push({
                        sort:nums,
                        trade_sn:item['订单编号'],
                        phone:item['联系手机'].substring(0,1)=="'" ? item['联系手机'].substring(1) : item['联系手机'],
                        name:item['收货人姓名'],
                        address:item['收货地址']
                    });
                });

                //清空输入框的文件值，避免下次change事件失效
                document.getElementById('fileupload').value = null;     
                _this.uploadloading=false;      
            }
            reader.readAsArrayBuffer(f);
          }

          if(rABS) {
        	  reader.readAsArrayBuffer(f);
          } else {
              reader.readAsBinaryString(f);
          }    
      },


      //上传天猫订单信息
      uploadTmallOrder() {
          this.uploadDialog=true;
          this.uploadLists=[];
      },

      //保存上传模板信息
      savemodel() {
          //取出订单信息
          if(this.uploadLists.length==0) {this.$message.error('请上传天猫订单数据');return false;}

          //开启加载特效
          this.showorderloading.display='flex';
          this.loadingpercent.width='0%';

          var _this=this;
          var num=0;
          var ordernums=this.uploadLists.length;
          var result;
          var percent;
          var timenum=0;
          var times=0;
          this.errorshows=[];
          var resource = this.$resource(this.url);
          
          this.uploadLists.forEach(function(item,i) {
            timenum++; times=timenum*1000;
            setTimeout(function() {
                num++;
                resource.save({act:'uploadTmallorder',token:_this.$cookies.get('token'),trade_sn:item.trade_sn,name:item.name,phone:item.phone,address:item.address,nums:item.nums}).then((res) => {
                    
                    if(res.data.Result>0) {
                        _this.errorshows.push(res.data.Message);
                        if(num!=ordernums) {
                            percent=num/ordernums*100;
                            _this.loadingpercent.width=percent+'%';
                        }
                        if(num==ordernums) {
                            percent=100;
                            _this.loadingpercent.width=percent+'%';
                            _this.showorderloading.display='none'; //关闭特效
                            _this.uploadDialog=false;
                            _this.getlists();
                            if(_this.errorshows.length > 0) _this.errorshowDialog=true;
                        }

                    }else {
                        if(num!=ordernums) { //没有加载完时
                            percent=num/ordernums*100;
                            _this.loadingpercent.width=percent+'%';

                        }else { //已经加载完成
                            percent=100;
                            _this.loadingpercent.width=percent+'%';
                            _this.showorderloading.display='none'; //关闭特效
                            _this.uploadDialog=false;
                            _this.getlists();
                            if(_this.errorshows.length > 0) _this.errorshowDialog=true;
                        }

                    }

                });

            },times);
          });

      },



     //加载孔明锁
     createLockKongMing() {
         let script = document.createElement('script');
         script.type = 'text/javascript';
         script.src = 'http://g.tbcdn.cn/sj/securesdk/0.0.3/securesdk_v2.js';
         script.id = 'J_secure_sdk_v2';
         script['data-appkey'] = '33361806';
         document.body.appendChild(script);
     },


     //生成销售出库单
     createsells(id) {
        var resource = this.$resource(this.url);
        resource.save({act:'Tmallcreatesell',token:this.$cookies.get('token'),id:id,cookies:document.cookie}).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
            }else{
                this.getlists(); //更新列表
            }
        }).catch((res) => {
            
        });
     },


     //获取订单信息详情
     getlists() {
        if(this.query.ischange) {
            this.query.p=1;
            this.query.rollpage=10;
        }

        this.query.loading=true;
        var resource = this.$resource(this.url);
        resource.save(this.query).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
                this.query.loading=false;
            }else{
                this.lists = JSON.parse(Base64.decode(res.data.Data));
                this.query.rows=parseInt(res.data.count);
                this.query.loading=false;
            }
        }).catch((res) => {
            this.query.loading=false;
        });

     },

     querypageSizeChange(val) {
        this.query.rollpage = val;
        this.getlists();
	 },
	 querypageCurrentChange(val) {
		this.query.p = val;
		this.getlists();
	 },



    //上一步
    upstep() {
        if(this.Tmallorders.index==0) return false;
        this.Tmallorders.index=0;
    },

    //下一步
    nextstep() {
        if(this.Tmallorders.index==1) return false;
        var _this=this;

        //替换字符串
        var basedata=this.Tmallorders.showorder1.replace(new RegExp("；","g"), ";");

        var index = basedata.lastIndexOf("\/");
        var datatemp  = basedata.substring(basedata.length-1, basedata.length);
        if(datatemp==';') basedata=basedata.substring(0,basedata.length-1);


        var data=basedata.split(";");
        this.Tmallorders.showorder2=[];
        data.forEach(function(item,index) {
            _this.Tmallorders.showorder2.push(item);
        });

        this.Tmallorders.index=1;
    },


	//手动获取天猫订单信息到本地
    handleSysTmallOrder() {
        this.Tmallorders.index=0;
        this.Tmallorders.showorder1='';
        this.Tmallorders.showorder2='';
        this.getTmallOrderDialog=true;
    },


    //保存天猫订单信息到本地
    saveTmallorder() {

        //取出订单信息
        var orderids=[];
        var _this=this;
        this.Tmallorders.showorder2.forEach(function(item,i) {orderids.push(item)});
        if(orderids.length==0) {this.$message.error('请输入需要提取的天猫订单号');return false;}

        //开启加载特效
        this.showorderloading.display='flex';
        this.loadingpercent.width='0%';

        var num=0;
        var ordernums=orderids.length;
        var result;
        var percent;
        var timenum=0;
        var times=0;
        this.errorshows=[];
        var lockcookie=this.$cookies.get('_ati');  //孔明锁cookie

        var resource = this.$resource(this.url);
        orderids.forEach(function(item,i) {
            timenum++; times=timenum*1000;
            setTimeout(function() {
                num++;
                resource.save({act:'saveTmallorder',token:_this.$cookies.get('token'),orderids:item}).then((res) => {
                    
                    if(res.data.Result>0) {
                        _this.errorshows.push(res.data.Message);
                        if(num!=ordernums) {
                            percent=num/ordernums*100;
                            _this.loadingpercent.width=percent+'%';
                        }
                        if(num==ordernums) {
                            percent=100;
                            _this.loadingpercent.width=percent+'%';
                            _this.showorderloading.display='none'; //关闭特效
                            _this.getTmallOrderDialog=false;
                            _this.getlists();
                            if(_this.errorshows.length > 0) _this.errorshowDialog=true;
                        }

                    }else {
                        if(num!=ordernums) { //没有加载完时
                            percent=num/ordernums*100;
                            _this.loadingpercent.width=percent+'%';

                        }else { //已经加载完成
                            percent=100;
                            _this.loadingpercent.width=percent+'%';
                            _this.showorderloading.display='none'; //关闭特效
                            _this.getTmallOrderDialog=false;
                            _this.getlists();
                            if(_this.errorshows.length > 0) _this.errorshowDialog=true;
                        }

                    }

                });

            },times);
        });

    },

    
    //获取功能权限
    getactionauth() {
    	var data =this.$cookies.get('actionauth');
    	data=JSON.parse(data);
        this.actionauth=data;
    },
    
   } 
}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
.Tmall-notice-warning {display:inline-block;padding:5px 20px;width:calc(100% - 40px);background:#E4E7ED;border-radius:6px;font-size:12px;line-height:23px;color:red;}
.Tmall-notice-title {display:inline-block;width:100%;margin-top:20px;font-size:0}
.Tmall-notice-title-infos {float:left;display:flex;justify-content:center;align-items:center;margin-right:5%;}
.Tmall-notice-title-number {float:left;display:flex;justify-content:center;align-items:center;font-size:13px;font-weight:bold;border:2px solid #909399;color:#fff;background:#909399;width:25px;height:25px;border-radius:50%}
.Tmall-notice-title-line {float:left;width:100px;height:2px;border-radius:15px;background:#909399;margin: 0 0 0 10px;}
.Tmall-notice-title-content {float:left;height:40px;display:flex;justify-content:center;align-items:center;}
.Tmall-notice-title-content-big {color:#909399;font-size:14px;font-weight:540;padding:0 10px;}

.Tmall-title-actived .Tmall-notice-title-number {color:#fff;border-color:#67C23A;background:#67C23A;}
.Tmall-title-actived .Tmall-notice-title-line {background:#67C23A;}
.Tmall-title-actived .Tmall-notice-title-content-big {color:#67C23A;}
.Tmall-notice-orderlists {float:left;padding:5px 10px;margin:5px 10px 5px 0;border-radius:15px;background:#DCDFE6;color:#303133;font-size:12px;line-height:21px;}

.tmall-order-id-style {font-size:13px;}
.tmall-order-sn-style {font-size:14px;display:inline-block;}
.tmall-order-shopname-style {font-size:12px;display:inline-block;}
.tmall-order-ispay-style {font-size:13px;line-height:21px;display:inline-block;width:100%}
.tmall-order-status-style {font-size:13px;line-height:21px;display:inline-block;width:100%}
.tmall-order-reciever {display:inline-block;font-size:13px;line-height:23px;margin-bottom:10px}
.tmall-order-handels {display:inline-block;width:100%;}
.tmall-order-goods {display:inline-block;width:100%;}
.tmall-order-goods-gift {position:absolute;font-size:12px;line-height:12px;color:#fff;background:red;right:0;top:0;padding:3px;border-radius:6px;}
.tmall-order-goods-img {float:left;width:65px;height:65px;border:1px solid rgba(221,221,221,.7);background:rgba(221,221,221,.3);border-radius:6px;display:flex;justify-content:center;align-items:center;position:relative;}
.tmall-order-goods-img img {border-radius:6px;max-width:85%;max-height:85%;}
.tmall-order-goods-name {float:left;width:calc(100% - 65px - 2px - 10px);margin-left:10px;line-height:23px;font-size:13px;}
.tmall-order-goods-spec {float:left;width:calc(100% - 65px - 2px - 10px);margin-left:10px;line-height:23px;font-size:12px;color:#999999}

.tmall-order-down-loading {position:fixed;width:100%;height:100%;top:0;left:0;background:rgba(0,0,0,.9);z-index:10000;display:flex;justify-content:center;align-items:center;}
.tmall-order-down-loading-main {display:inline-block;width:30%;text-align:center;}
.tmall-order-down-main-notice {font-size:13px;line-height:23px;color:#ffdd03;-webkit-animation-timing-function:ease-in-out;-webkit-animation-name:goingdown;-webkit-animation-duration:1000ms;-webkit-animation-iteration-count:infinite;-webkit-animation-direction:alternate;}
.tmall-order-down-main-percentout {width:60%;text-align:center;position:relative;padding:5px;font-size:13px;line-height:23px;border-radius:15px;overflow:hidden;border:1px solid #ffdd03;color:#ffdd03;margin:0 auto;margin-top:20px;}
.tmall-order-down-main-percent {position:absolute;height:100%;background:#ffdd03;border-radius:0 15px 15px 0;transition:.6s all;top:0;left:0;}

@-webkit-keyframes goingdown {
	0% {
	    opacity:0;
	    text-shadow:0 0 0 #ffdd03;
    }
    100% {
	    opacity:1;
    	text-shadow:0 0 10px #ffdd03;
    }
}

.tmall-order-down-error-shows {display:flex;align-items:center;width:calc(100% - 2px - 40px);padding:3px 20px;border:1px solid #f56c6c;background:#fef0f0;font-size:12px;color:#f56c6c;border-radius:6px;line-height:23px;margin-bottom:10px;}
.tmall-order-down-error-shows img {width:20px;height:20px;border-radius:50%;margin-right:10px;}
.tmall-upload-total {display:inline-block;width:calc(100% - 20px);padding:10px 20px 10px 0;color:red;text-align:right;font-size:13px;}
</style>


// WEBPACK FOOTER //
// src/components/tmall/TMallOrders.vue